<template>

<app-wrapper>

    <com-list v-on:create="onCreateClick" v-if="!is.booking && !is.success" />
    <com-book v-on:cancel="onCancelClick" v-on:success="onSuccess" v-if="is.booking" />
    <com-success v-if="is.success" v-on:back="onCancelClick" />

</app-wrapper>

</template>

<script>

import comList from './adverts/List'
import comBook from './adverts/Book'
import comSuccess from './adverts/Success'

export default {

    components: {
        'com-list': comList,
        'com-book': comBook,
        'com-success': comSuccess
    },

    data: function() {

        return {
            is: {
                booking: false,
                success: false
            }
        }

    },

    created: function() {

        if (this.$route.meta.cancel || this.$route.meta.success) {

            this.is.booking = true

        }

    },

    methods: {

        onSuccess: function() {

            this.is.booking = false
            this.is.success = true

        },

        onCreateClick: function() {

            this.is.booking = true

        },

        onCancelClick: function() {

            this.is.booking = false
            this.is.success = false

        }

    }

}

</script>

<style scoped>

</style>